import script from "./DomainSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./DomainSearch.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__